module.exports = __webpack_public_path__ + "static/media/legendaryengram.1b69ec27.ogg";